// import React, { useState, useEffect, useRef } from 'react';
// import './css/Timer.css';

// const Timer = ({lastRelapseDate}) => {
//     const [days, setDays] = useState('0');
//     const [hours, setHours] = useState('0');
//     const [minutes, setMinutes] = useState('0');
//     const [seconds, setSeconds] = useState('0');
//     const startDate = useRef(lastRelapseDate); // Using ref

//     useEffect(() => {
//         // Update startDate ref when lastRelapseDate prop changes
//         startDate.current = new Date(lastRelapseDate).getTime();
//     }, [lastRelapseDate]);

//     const getTime = (startDate) => {
//         const now = Date.now();
//         const time = now - startDate;

//         if (isNaN(time)) {
//             return;
//         }
        
//         const totalSeconds = Math.floor(time / 1000);
//         const totalMinutes = Math.floor(totalSeconds / 60);
//         const totalHours = Math.floor(totalMinutes / 60);
//         const totalDays = Math.floor(totalHours / 24);

//         let days = Math.floor(totalDays);
//         let hours = Math.floor(totalHours % 24);
//         let minutes = Math.floor(totalMinutes % 60);
//         let seconds = Math.floor(totalSeconds % 60);

//         setDays(days);
//         setHours(hours);
//         setMinutes(minutes);
//         setSeconds(seconds);
//     };

//     useEffect(() => {
//         const interval = setInterval(() => getTime(startDate.current), 1000);
//         return () => clearInterval(interval);
//     }, []);

//     return (
//         <div className="timer" role="timer">
//             <div className="col-4">
//             <div className="box">
//                 <p id="day">{days < 10 ? "0" + days : days}</p>
//                 <span className="text">Days</span>
//             </div>
//             </div>
//             <div className="col-4">
//             <div className="box">
//                 <p id="hour">{hours < 10 ? "0" + hours : hours}</p>
//                 <span className="text">Hours</span>
//             </div>
//             </div>
//             <div className="col-4">
//             <div className="box">
//                 <p id="minute">{minutes < 10 ? "0" + minutes : minutes}</p>
//                 <span className="text">Minutes</span>
//             </div>
//             </div>
//             <div className="col-4">
//             <div className="box">
//                 <p id="second">{seconds < 10 ? "0" + seconds : seconds}</p>
//                 <span className="text">Seconds</span>
//             </div>
//             </div>
//         </div>
//     );
// };


// export default Timer;

import React, { useState, useEffect, useRef } from 'react';
import './css/Timer.css';

const Timer = ({ lastRelapseDate }) => {
    const [days, setDays] = useState('0');
    const [hours, setHours] = useState('0');
    const [minutes, setMinutes] = useState('0');
    const [seconds, setSeconds] = useState('0');
    const startDate = useRef(new Date(lastRelapseDate).getTime()); // Initialize with valid date

    useEffect(() => {
        // Validate and update startDate ref when lastRelapseDate prop changes
        const newDate = new Date(lastRelapseDate).getTime();
        if (!isNaN(newDate)) {
            startDate.current = newDate;
        } else {
            console.error("Invalid lastRelapseDate:", lastRelapseDate);
        }
    }, [lastRelapseDate]);

    const calculateTime = () => {
        const now = Date.now();
        const elapsedTime = now - startDate.current;

        if (elapsedTime < 0 || isNaN(elapsedTime)) {
            console.error("Elapsed time is invalid:", elapsedTime);
            return;
        }

        const totalSeconds = Math.floor(elapsedTime / 1000);
        const totalMinutes = Math.floor(totalSeconds / 60);
        const totalHours = Math.floor(totalMinutes / 60);
        const totalDays = Math.floor(totalHours / 24);

        setDays(totalDays);
        setHours(totalHours % 24);
        setMinutes(totalMinutes % 60);
        setSeconds(totalSeconds % 60);
    };

    useEffect(() => {
        const interval = setInterval(calculateTime, 1000);

        // Cleanup interval on component unmount
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="timer" role="timer">
            <div className="col-4">
                <div className="box">
                    <p id="day">{days.toString().padStart(2, '0')}</p>
                    <span className="text">Days</span>
                </div>
            </div>
            <div className="col-4">
                <div className="box">
                    <p id="hour">{hours.toString().padStart(2, '0')}</p>
                    <span className="text">Hours</span>
                </div>
            </div>
            <div className="col-4">
                <div className="box">
                    <p id="minute">{minutes.toString().padStart(2, '0')}</p>
                    <span className="text">Minutes</span>
                </div>
            </div>
            <div className="col-4">
                <div className="box">
                    <p id="second">{seconds.toString().padStart(2, '0')}</p>
                    <span className="text">Seconds</span>
                </div>
            </div>
        </div>
    );
};

export default Timer;